import { Component, Input } from '@angular/core';
import { BulletItemModel } from '@core/models/bullet';
import { UiService } from '@core/services/ui/ui.service';

@Component({
  selector: 'app-bullet-list',
  templateUrl: './bullet-list.component.html',
  styleUrls: ['./bullet-list.component.scss'],
  standalone: false
})
export class BulletListComponent {
  @Input() bullets: BulletItemModel[] = [];

  constructor(private uiService: UiService) {}

  openInfoModal(message: string): void {
    this.uiService.showTooltipAsModal({
      title: message + '_info-title',
      description: message + '_info-description'
    });
  }
}
